(function ($) {
  "use strict";

  $(function () {
    $(window).on("load", function () {
      //   $(".-form input[type=text]").each(function (i, el) {
      //     console.log(el.id);
      //     if (!el.value || el.value == "") {
      //       console.log(el.id);
      //       el.placeholder = $("label[for=" + el.id + "]").attr("placeholder");
      //     }
      //   });
    });
  });
})(jQuery);
